<template>
  <div class="mind524-page" :style="pageStyle">
    <div class="game-screen" :style="gameScreenStyle">
      <transition name="slide-fade"></transition>
      <!-- <transition name="slide-fade">
        <div
          class="main-content-area"
          :style="mainContentAreaStyle"
          v-if="game.scene === 'S1' && game.dataReady.S1"
        >
          <textBgWave
            class="circle-wave-component"
          />
          <div class="top-title">ㄑ
            <div v-html="gameDisplay.topTitle"></div>
          </div>
          <div class="top-content" :style="topContentStyle">
            <div v-html="gameDisplay.mainContent"></div>
          </div>
        </div>
      </transition> -->
      <transition name="slide-fade">
        <div class="text-wave-bg-wrapper" :style="waveBgWrapperStyle">
          <div class="text-wave-bg" :style="waveBgStyle">
            <textBgWave :color="'linear-gradient(94.84deg, #665ABE 20.95%, #3B348E 82.95%)'" width="85%" v-if="game.scene === 'S1' && game.dataReady.S1" />
          </div>
        </div>
      </transition>
      <transition name="slide-fade">
        <div class="main-content-area" :style="mainContentAreaStyle" v-if="game.scene === 'S1' && game.dataReady.S1">
          <div class="top-title">
            <div v-html="gameDisplay.topTitle"></div>
          </div>
          <div class="top-content" :style="topContentStyle">
            <div class="main-content" v-html="gameDisplay.mainContent"></div>
          </div>
          <div class="content-player-outer" :style="contentPlayerOuterStyle" v-if="game.scene === 'S1' && game.dataReady.S1">
            <div class="content-player">
              <button class="hover" style="margin-right: 16px;" @click="btnPlayerPrimary()">
                <img :src="contentPlayerRect.mainBtnImg" alt="" srcset="" />
              </button>
              <button class="hover" @click="btnReplay()">
                <img :src="img.replay" alt="" srcset="" />
              </button>
            </div>
          </div>
        </div>
      </transition>
      <!-- 吉祥物 1 的圖 -->
      <transition name="slide-fade">
        <img class="pos-abs" :src="img.mascot1" v-if="mascot1Rect.show" :style="mascot1Style" />
      </transition>
      <!-- 吉祥物 2 的圖 -->
      <transition name="slide-fade">
        <img class="pos-abs" :src="img.mascot2" v-if="mascot2Rect.show" :style="mascot2Style" />
      </transition>
      <!-- 底下的浮動視窗 -->
      <transition name="slide-fade">
        <div class="float-area-outer" :style="floatAreaOuterStyle" v-if="floatAreaRect.show">
          <ItemWave color="245, 238, 247" :height="floatAreaRect.waveHeight + 'px'"></ItemWave>
          <div class="float-area" :style="floatAreaStyle">
            <transition name="slide-fade">
              <div class="content-s1" v-if="game.scene === 'S1' && game.dataReady.S1">
                <div class="date-area">
                  <div class="d-flex justify-between-space">
                    <span v-html="gameDisplay.dateStr"></span>
                    <span v-html="this.game.dayDiff > 0 ? gameDisplay.dayStr : ''"></span>
                  </div>
                </div>
                <div class="bottom-title-1" style="margin-top: 32px;">
                  <div v-html="gameDisplay.bottomTitle1"></div>
                </div>
              </div>
            </transition>
            <!-- 左下角文字編輯按鈕(鉛筆圖示) -->
            <transition name="slide-fade">
              <div class="pencil-area hover" v-show="pencilAreaRect.show" :style="pencilAreaStyle" @click="btnPencil">
                <div :style="pencilAreaWrapperStyle">
                  <v-icon :style="pencilStyle" :color="pencilAreaRect.color" :size="pencilAreaRect.size" v-text="pencilAreaRect.icon"></v-icon>
                </div>
              </div>
            </transition>
            <!-- 左下角錄音按鈕 -->
            <transition name="slide-fade">
              <div class="mic-area hover" v-show="micAreaRect.show" :style="micAreaStyle" @click="btnRecorder">
                <div :style="micAreaWrapperStyle">
                  <v-icon :style="micStyle" :color="micAreaRect.color" :size="micAreaRect.size" v-text="micAreaRect.icon"></v-icon>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </transition>
      <transition name="slide-fade">
        <div class="bottom-loadding" :style="bottomLoaddingStyle" v-if="bottomLoaddingRect.show">
          <div class="bottom-loadding-img-wrapper">
            <img :src="img.loadding" :width="bottomLoaddingRect.imgWidth" :height="bottomLoaddingRect.imgHeight" />
          </div>
          <div class="bottom-loadding-text">
            正在把回應傳送給宇宙分析中...
          </div>
        </div>
      </transition>
      <div class="start-view" v-if="!game.start">
        <div class="start-view-innert">
          <div class="input-form">
            <img class="start-img-voiss" :src="img.voiss" alt="" @click="btnLogin" />
            <br />
            <div class="form-content">
              <input v-model="user.nickname" class="text-input" type="text" placeholder="輸入暱稱" />
              <input v-model="game.sid" class="text-input" type="text" placeholder="輸入心靈空間代號" />
              <!-- <div style="text-align:right">
                <button color="#4E4DA8" class="login-btn hover" @click="btnLogin">
                  登入
                </button>
              </div> -->
              <button color="#4E4DA8" class="start-btn hover" @click="btnStartGame">
                開始練習
              </button>
            </div>
          </div>
          <div class="start-view-float-desc">
            <!-- 你即將進入<span style="color:#F2C94C">缺點擊破訓練場</span> -->
            <br />
            用聲音互動，體驗他人的真實心聲
            <br />
            瞄準思維，洞察學習
          </div>
          <div class="start-view-mute">
            <button class="start-view-mute-btn hover" @click.stop="btnToggleStartBGM">
              <v-icon size="16" color="#FFFFFF">
                {{ startViewMuteIcon }}
              </v-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    <FullscreenTextInput
      :width="gameScreenRect.width"
      :height="gameScreenRect.height"
      :top="gameScreenRect.top"
      :left="gameScreenRect.left"
      :show.sync="textInput.show"
      placeholder="(點擊輸入回答，例如: 這表示我....)"
      background="#111D"
      v-model="textInput.value"
      @submit="inputByText($event)"
      @close="textInput.value = ''"
    >
      <div style="margin-top:20%; color:white; margin-bottom:16px;" v-html="textInput.descHTML"></div>
    </FullscreenTextInput>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import { get, debounce } from 'lodash'
import mustache from 'mustache'
import {
  storyContinue,
  getUserStt,
  saveLoginToken,
  getLoginToken,
  saveS2PageData,
  saveNickname,
  getNickname
} from '@/lib/mind524'
import resizeMixins from '@/mixins/resize'
import ItemWave from '@/components/ItemWave'
import textBgWave from '@/components/textBgWave'
import FullscreenTextInput from '@/components/FullscreenTextInput'
import { voissLogin, getUserInfo } from '@/lib/voiss-auth'

export default {
  mixins: [resizeMixins],
  components: {
    ItemWave,
    textBgWave,
    FullscreenTextInput
  },
  computed: {
    screen () {
      const { height, width } = this.$store.state.screen
      return {
        height: height - 1,
        width
      }
    },
    startViewMuteIcon () {
      return this.startBGMPlaying ? 'mdi-volume-high' : 'mdi-volume-off'
    },
    // ------------ Rect (計算顯示用物件的相關屬性) ------------
    gameScreenRect () {
      const screen = this.screen
      // const gameHeight = screen.height
      // const w = gameHeight * (375 / 812)
      const w = 414
      // console.log(`'375/812 = ${w}/'${gameHeight}`)
      const gameWidth = screen.width > w ? w : screen.width
      // if (gameWidth > w) {
      //   gameWidth = w
      // }
      const left = screen.width / 2 - gameWidth / 2
      return {
        top: 0,
        left,
        height: screen.height,
        width: gameWidth
      }
    },
    mainContentAreaRect () {
      const { height, width } = this.gameScreenRect
      return {
        show: this.game.start,
        height: height * 0.55,
        width: width
      }
    },
    topContentRect () {
      const { height: mHeight } = this.mainContentAreaRect
      return {
        height: mHeight * 0.7
      }
    },
    contentPlayerRect () {
      return {
        imgSize: 40,
        mainBtnImg: this.game.msgPlaying ? this.img.pause : this.img.play
      }
    },
    floatAreaRect () {
      const { height, width } = this.gameScreenRect
      const { uploading } = this.recorder
      const h = height * 0.45
      return {
        show: this.game.start && !uploading,
        top: height - h,
        height: h,
        width: width,
        waveHeight: 40
      }
    },
    bottomLoaddingRect () {
      const { height, width, top } = this.floatAreaRect
      const { uploading } = this.recorder
      return {
        show: uploading,
        height,
        width,
        top,
        imgHeight: 130,
        imgWidth: 130
      }
    },
    mascot1Rect () {
      const { top, show } = this.floatAreaRect
      return {
        show,
        top: top - 50,
        left: 16
      }
    },
    mascot2Rect () {
      const { width } = this.gameScreenRect
      const { top } = this.floatAreaRect
      const show = this.game.start && this.game.dataReady.S1 && this.game.msgPlaying
      return {
        show,
        top: top - 10,
        left: width / 2 - 31.5
      }
    },
    micAreaRect () {
      const { width } = this.gameScreenRect
      let size = width * 0.3
      if (size > 100) {
        size = 100
      } else if (size < 30) {
        size = 30
      }
      const iconColor = '#1D1B82'
      let micColor = iconColor
      let icon = 'mdi-microphone'
      if (this.recorder.recording) {
        icon = 'mdi-stop'
        micColor = '#F44'
      }
      const show = this.game.start && this.game.dataReady.S1 && this.game.scene === 'S1'
      return {
        size,
        show,
        micSize: size / 2,
        color: '#F2C94B',
        micColor,
        iconColor,
        icon
      }
    },
    // 左下角麥克風旁邊的文字輸入按鈕
    pencilAreaRect () {
      const { size, show, micSize, iconColor } = this.micAreaRect
      const selfSize = size * 1.7
      return {
        size: selfSize,
        show,
        iconSize: micSize * 0.65,
        color: '#E78686',
        iconColor,
        icon: 'mdi-pencil',
        left: 7,
        bottom: -(selfSize / 2) - 20
      }
    },
    // ------------ Styles ------------
    pageStyle () {
      const { height, width } = this.screen
      return {
        height: height + 'px',
        width: width + 'px'
      }
    },
    gameScreenStyle () {
      const { top, left, height, width } = this.gameScreenRect

      return {
        top: `${top}px`,
        left: `${left}px`,
        height: `${height}px`,
        width: `${width}px`,
        backgroundColor: '#F5EEF7'
      }
    },
    waveBgWrapperStyle () {
      const { width } = this.mainContentAreaRect
      const { height } = this.topContentRect
      return {
        position: 'absolute',
        top: '90px',
        height: height * 1.05 + 'px',
        width: width + 'px'
      }
    },
    waveBgStyle () {
      const { height, width } = this.mainContentAreaRect
      return {
        position: 'absolute',
        paddingTop: '80px',
        height: height * 1 + 'px',
        width: width * 1.2 + 'px'
      }
    },
    mainContentAreaStyle () {
      const { height, width } = this.mainContentAreaRect
      return {
        top: '0px',
        height: height + 'px',
        width: width + 'px'
      }
    },
    topContentStyle () {
      const { height } = this.topContentRect
      return {
        height: height + 'px'
      }
    },
    contentPlayerOuterStyle () {
      const { height, width } = this.mainContentAreaRect
      const { imgSize } = this.contentPlayerRect
      return {
        top: height - 50 + 'px',
        left: width / 2 - imgSize / 2 + 'px'
      }
      // position: absolute;
      // top: 381px;
      // left: 200px;
    },
    floatWaveStyle () {
      const { width, top } = this.floatAreaRect
      return {
        top: top + 'px',
        width: width + 'px'
      }
    },
    bottomLoaddingStyle () {
      const { height, width, top } = this.bottomLoaddingRect
      return {
        top: top + 'px',
        height: height + 'px',
        width: width + 'px'
      }
    },
    floatAreaOuterStyle () {
      const { height, width, top } = this.floatAreaRect
      return {
        top: top + 'px',
        height: height + 'px',
        width: width + 'px'
      }
    },
    floatAreaStyle () {
      const { height, waveHeight } = this.floatAreaRect

      return {
        height: height - waveHeight + 'px'
      }
    },
    mascot1Style () {
      const { top, left } = this.mascot1Rect
      return {
        top: top + 'px',
        left: left + 'px'
      }
    },
    mascot2Style () {
      const { top, left } = this.mascot2Rect
      return {
        top: top + 'px',
        left: left + 'px'
      }
    },
    micAreaStyle () {
      const { size, color } = this.micAreaRect
      return {
        height: size + 'px',
        width: size + 'px',
        backgroundColor: color,
        borderRadius: `0 ${size}px 0 0`
      }
    },
    micAreaWrapperStyle () {
      const { size, micSize } = this.micAreaRect
      return {
        display: 'inline-block',
        marginTop: size / 2 - micSize / 3 + 'px',
        marginLeft: size / 7 + 'px'
      }
    },
    micStyle () {
      const { micColor, micSize } = this.micAreaRect
      return {
        fontSize: micSize + 'px',
        color: micColor
      }
    },
    pencilAreaStyle () {
      const { size, color, left, bottom } = this.pencilAreaRect
      return {
        height: size + 'px',
        width: size + 'px',
        backgroundColor: color,
        borderRadius: `${size}px ${size}px 0 0`,
        left: left + 'px',
        bottom: bottom + 'px'
      }
    },
    pencilAreaWrapperStyle () {
      const { size, iconSize } = this.pencilAreaRect
      return {
        display: 'inline-block',
        marginTop: size / 8 + 'px',
        marginLeft: (size + iconSize) / 2 + 'px'
      }
    },
    pencilStyle () {
      const { iconColor, iconSize } = this.pencilAreaRect
      return {
        fontSize: iconSize + 'px',
        color: iconColor
      }
    }
  },
  data () {
    return {
      login: true,
      convId: null,
      user: {
        nickname: ''
      },
      // 起始畫面的 BGM
      startBGM: 'https://storage.googleapis.com/voiss-mini/socialcommunity-2nd/%E9%96%8B%E5%A0%B4%E9%9F%B3%E6%A8%82_%E5%A4%A9%E5%A0%82.mp3',
      startBGMPlaying: false,
      img: {
        mascot1: require('@/assets/mind524/img/mascot-1.png'),
        mascot2: require('@/assets/mind524/img/mascot-2.png'),
        play: require('@/assets/mind524/img/play.png'),
        pause: require('@/assets/mind524/img/pause.png'),
        replay: require('@/assets/mind524/img/replay.png'),
        recordPause: require('@/assets/mind524/img/record-pause.png'),
        recordPlay: require('@/assets/mind524/img/record-play.png'),
        jumpBack: require('@/assets/mind524/img/jump-back.png'),
        music: require('@/assets/mind524/img/music.png'),
        voiss: require('@/assets/mind524/img/voiss-start.png'),
        loadding: require('@/assets/mind524/img/loadding.svg')
      },
      color: {
        // 畫面 1 相關
        text0: '#2D234C', // 最上面的標題
        text1_1: '#FCFCFC', // 畫面上面的 content
        text2: '#30234E', // 日期
        text3_1: '#4A3966', // 底下浮動視窗的 content
        highlight0: '#504EA9', // 上面的 title 的部分
        highlight1: '#FF6B6B', // 底下浮動視窗的 content

        // 畫面 2 額外修改
        text1_2: '#202042', // 畫面上面的 content
        text3_2: '#5F5078', // 底下浮動視窗的 content
        text4: '484BA4', // stt 的部分
        edit: '#000', // 編輯時的文字
        save: '#9F97CE' // 存檔鈕
      },
      textInput: {
        show: false,
        descHTML: '',
        value: ''
      },
      recorder: {
        recording: false,
        uploading: false,
        startTime: new Date(),
        stopTime: new Date()
      },
      game: {
        sid: '',
        start: false,
        scene: 'S1',
        data: {},
        dataReady: {
          S1: false,
          S2: false
        },
        msgPlaying: false,
        playIndex: -1,
        // 是活動開始的第幾天
        dayDiff: -1,
        // msg action 的 audio
        contentAudios: [],
        content: {
          topTitle: '',
          mainContent: '',
          dateStr: '',
          dayStr: '',
          bottomTitle1: '',
          bottomTitle2: ''
        }
      },
      // 這裡裝的資料全部都是從 game.content.* 轉化的 html
      gameDisplay: {
        topTitle: '',
        mainContent: '',
        dateStr: '',
        dayStr: '',
        bottomTitle1: '',
        bottomTitle2: ''
      },

      contentSettings: {
        top_title_1: {
          to: 'topTitle',
          preParse: (content, datas, parseOpts) => {
            let quesTitle = datas.quesTitle || ''
            if (quesTitle.length > 7) {
              quesTitle = quesTitle.substr(0, 7) + '..'
            }
            datas.quesTitle = quesTitle
            return content
          },
          highlight: 'color:highlight0'
        },
        bottom_date_new: {
          to: (content, datas, parseOpts) => {
            const sp = content.split('\n')
            if (sp.length >= 2) {
              this.game.content.dateStr = sp[0]
              this.game.content.dayStr = sp[1]
              this.gameDisplay.dateStr = this.parseContent(this.game.content.dateStr, datas, parseOpts)
              this.gameDisplay.dayStr = this.parseContent(this.game.content.dayStr, datas, parseOpts)
            } else if (sp.length === 1) {
              this.game.content.dateStr = content
              this.gameDisplay.dateStr = this.parseContent(content, datas, parseOpts)
            }
          }
        },
        bottom_title_1: {
          to: 'bottomTitle1',
          highlight: 'color:highlight0'
        }
      }
    }
  },
  mounted () {
    this.updateLoginState()
    const name = getNickname()
    this.user.nickname = name.replace('a:', '').trim()
    const audio = new Audio()
    console.log('audio', audio)
    audio.addEventListener('paused', () => {
      console.log('audio on paused')
    })
    audio.addEventListener('ended', this.onAudioEnd)
    audio.addEventListener('error', this.onAudioError)
    this.$audio = audio
    const sid = this.$route.query.sid
    if (sid && sid.match(/\d+/)) {
      this.game.sid = sid
    }
    // 測試用
    window.$$sim = this.sim.bind(this)

    audio.src = this.startBGM
    audio.volume = 0.7
    audio
      .play()
      .then(() => {
        this.startBGMPlaying = true
      })
      .catch(() => {
        this.startBGMPlaying = false
        // 自動播放被拒絕時
        const fn = () => {
          if (!this.game.start) {
            audio.play()
            this.startBGMPlaying = true
            window.removeEventListener('click', fn)
          }
        }
        window.addEventListener('click', fn)
      })
  },
  beforeDestroy () {
    this.$audio.pause()
    this.$audio = null
    this.$onRecorderResults = null
    this.recorderStop()
  },
  methods: {
    async updateLoginState () {
      const token = getLoginToken()
      if (token) {
        console.log('ttt', token)
        const data = await getUserInfo(token)
        console.log(data)
        this.login = true
      }
    },
    async btnLogin () {
      const res = await voissLogin()
      saveLoginToken(res.token)
      console.log('login:', res)
      const data = await getUserInfo(res.token)
      console.log('user:', data)
    },
    async sim (text) {
      await this.inputByText(text)
    },
    btnToggleStartBGM () {
      const audio = this.$audio
      if (!this.startBGMPlaying) {
        audio
          .play()
          .then(() => {
            this.startBGMPlaying = true
          })
          .catch(() => {
            this.startBGMPlaying = false
          })
      } else {
        audio.pause()
        this.startBGMPlaying = false
      }
    },
    /**
     * 開始遊戲的按鈕
     */
    async btnStartGame () {
      if (!this.game.start) {
        this.game.start = true
        const { sid, scene } = this.game
        try {
          if (this.$route.query.sid !== sid) {
            this.$router.replace(`/mind524?sid=${sid}`)
          }
          saveNickname(this.user.nickname)
          const results = await storyContinue(sid, scene, {
            convId: this.convId,
            data: this.game.data,
            userId: 'a:' + this.user.nickname
          })
          if (results.convId) {
            this.convId = results.convId
          }
          Object.assign(this.game.data, results.next.data)
          this.game.dayDiff = results.next.data.dayDiff
          await this.delay(300)
          await this.handleActions(results.actions, results.next)
          this.game.dataReady.S1 = true
        } catch (e) {
          this.game.start = false
          console.warn(e)
        }
      }
    },
    btnPlayerPrimary () {
      if (!this.game.msgPlaying) {
        this.playMsgAudio()
      } else {
        this.pauseMsgAudio()
      }
    },
    btnReplay () {
      this.replayMsgAudio()
    },

    async btnRecorder () {
      if (this.recorder.uploading) {
        return
      }
      if (!this.recorder.recording) {
        this.recorder.recording = true
        this.pauseMsgAudio()
        this.recorderStart()
      } else {
        const { sid } = this.game
        this.recorderStop()
        this.recorder.uploading = true
        this.$onRecorderResults = async (audio, sttText) => {
          this.recorder.uploading = false
          const results = await storyContinue(sid, 'S2', {
            text: sttText,
            convId: this.convId,
            data: this.game.data,
            userId: 'a:' + this.user.nickname,
            hasAudio: true
          })
          if (results.convId) {
            this.convId = results.convId
          }
          if (results.error && results.error.length > 0) {
            return await this.handleM524ApiErrorActions(results)
          }
          await this.toS2Page(results)
        }
      }
    },
    btnPencil () {
      this.textInput.show = !this.textInput.show
    },
    async inputByText (text, opts = {}) {
      if (!text && !opts.allowEmpty) return
      const { sid } = this.game
      const results = await storyContinue(sid, 'S2', {
        text,
        convId: this.convId,
        data: this.game.data,
        userId: 'a:' + this.user.nickname
      })
      if (results.convId) {
        this.convId = results.convId
      }
      if (results.error && results.error.length > 0) {
        return await this.handleM524ApiErrorActions(results)
      }
      await this.toS2Page(results)
    },

    async handleM524ApiErrorActions (results) {
      console.warn('show api msg', results.error)
      this.showApiFailMessage(
        results.text,
        results.error
          .map(err => err.message)
          .join('<br>')
          .replace(/\n/, '<br>')
      )
      // ...
    },
    showApiFailMessage (textareaValue, descHTML) {
      this.textInput.value = textareaValue
      this.textInput.descHTML = descHTML
      this.textInput.show = true
    },
    /**
     * @param {Object} results mind524 api result
     */
    async toS2Page (results) {
      Object.assign(this.game.data, results.next.data)
      this.game.scene = 'S2'
      await this.delay(1000)
      await this.handleActions(results.actions, results.next, { noPlayAudio: true })
      this.game.dataReady.S2 = false
      const data = results.next.data
      const audios = this.game.contentAudios.filter(a => !!a)
      const replyInfo = this.game.replyInfo
      const replyAudio = replyInfo ? replyInfo.url : ''

      const s2PageData = {
        convId: this.convId,
        storyId: this.game.sid,
        reviewName: data.authorName,
        playerTitle_name: data.authorName3,
        titleName: data.authorName2,
        reviewContent: results.text,
        responseMedia: audios,
        playerMedia: replyAudio,
        reponseContent: this.gameDisplay.mainContent
      }
      if (replyInfo && replyInfo.info) {
        s2PageData.playerTitle_1 = replyInfo.info.text1 || undefined
        s2PageData.playerTitle_2 = replyInfo.info.text2 || undefined
      }
      await saveS2PageData(s2PageData)
      this.$router.push('/mind524/end')
    },
    async onRecorderResults (audio) {
      this.recorder.recording = false
      if (this.$onRecorderResults) {
        const { startTime, stopTime } = this.recorder
        if (stopTime - startTime < 1000) {
          this.showApiFailMessage(
            '', // textarea value
            '好像沒有錄到你說的話😢\n如果發現你的手機一直不能成功錄音，可以點選鉛筆圖案，試試看打字輸入功能呦!'
          )
          return
        }

        const stt = await getUserStt(audio, this.convId)
        let text = null
        if (stt) {
          text = stt.text
        }
        // 確保動態效果播放完畢
        await this.delay(1000)
        this.recorder.uploading = false
        await this.$onRecorderResults(audio, text)
      }
    },
    recorderStart () {
      return new Promise((resolve, reject) => {
        navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
          // 因為請求權限是非同步的，
          // 有可能執行到該位置時剛好 user 已經按下停止錄音
          // 因此在該位置新增一個檢查
          if (!this.recorder.recording) {
            stream.getTracks().forEach(i => i.stop())
            return
          }
          const $recorder = (this.$recorder = new MediaRecorder(stream))

          // Set record to <audio> when recording will be finished
          $recorder.addEventListener('dataavailable', e => {
            this.onRecorderResults(e.data)
          })

          // Start recording
          $recorder.start()
          this.recorder.startTime = new Date()
        })
      })
    },

    async recorderStop () {
      const recorder = this.recorder
      if (!recorder.uploading && recorder.recording) {
        recorder.recording = false
        const $recorder = this.$recorder
        if ($recorder) {
          // Stop recording
          this.recorder.stopTime = new Date()
          $recorder.stop()
          // Remove “recording” icon from browser tab
          $recorder.stream.getTracks().forEach(i => i.stop())
        }
      }
    },
    async handleActions (actions, next, opts = {}) {
      const noPlayAudio = opts.noPlayAudio
      this.resetPlayer()
      this.game.contentAudios = []
      this.game.content.mainContent = ''
      for (const action of actions) {
        switch (action.type) {
          case 'set_content':
            this.setContent(action.data.place, action.data.content, action.data.vars)
            break
          case 'set_reply_audio':
            this.setReplyAudio(action.data)
            break
          case 'msg':
            this.handleMsgAction(action.data)
            break

          default:
            console.warn(`unknown action ${action.type}`)
        }
      }
      const mainContentOpts = {
        color: this.game.scene === 'S1' ? this.color.text1_1 : this.color.text1_2
      }
      this.gameDisplay.mainContent = this.parseContent(this.game.content.mainContent.trim(), next.data, mainContentOpts)
      this.textInput.descHTML = this.gameDisplay.bottomTitle1
      console.log('player.queue', this.game.contentAudios)
      this.resetPlayer()
      if (!noPlayAudio) {
        this.playMsgAudio()
      }
    },
    handleMsgAction (actionData) {
      this.game.content.mainContent += (actionData.text || '') + '\n'
      this.game.contentAudios.push(actionData.audio)
    },
    /**
     * @param {String} name 要放的位子
     * @param {String} content 內容 template
     * @param {Object} datas 要填入的變數
     */
    setContent (name, content, datas) {
      const contentSettings = this.contentSettings
      datas = datas || {}
      // console.log('set_content', name)
      // console.log(content)
      // console.log('----------')
      if (contentSettings[name]) {
        const { to, preParse, color, highlight } = contentSettings[name]
        const parseOpts = {
          color: this.parseColorArgs(color),
          highlight: this.parseColorArgs(highlight)
        }
        console.log('set content parseOpts', parseOpts, contentSettings[name])
        if (typeof preParse === 'function') {
          content = preParse(content, datas, parseOpts)
        }
        if (typeof to === 'function') {
          console.log('call func for content')
          to(content, datas, parseOpts)
        } else {
          console.log('set content to', to)
          if (to in this.game.content) {
            this.game.content[to] = content
            const parsed = this.parseContent(content, datas, parseOpts)
            this.gameDisplay[to] = parsed
          }
        }
      } else {
        console.log('set_content ignore', name)
      }
    },
    setReplyAudio (actionData) {
      const baseURL = 'https://voiss-mini.s3-ap-southeast-1.amazonaws.com/socialcommunity-2nd/'
      const url = baseURL + actionData.audio
      this.game.replyInfo = {
        ...actionData,
        url
      }
    },
    /**
     * @param {String} colorArg
     */
    parseColorArgs (colorArg) {
      if (!colorArg) return null
      const sp = colorArg.split(':')
      if (sp.length === 1) {
        return sp[0]
      } else if (sp.length >= 2) {
        if (sp[0] === 'color') {
          if (this.color[sp[1]]) {
            return this.color[sp[1]]
          } else {
            console.warn(`color "${sp[1]}" not found`)
          }
        }
        return null
      } else {
        return null
      }
    },
    parseContent (content, datas, opts = {}) {
      datas = datas || {}
      const parts = mustache.parse(content)
      const { color, highlight } = opts
      let html = parts
        .map(args => {
          const [type, text] = args
          if (type === 'text') {
            return text
          } else if (type === 'name') {
            if (datas[text] != null) {
              if (highlight) {
                return `<span style="color:${highlight};">${datas[text]}</span>`
              } else {
                return `<span>${datas[text]}</span>`
              }
            } else {
              console.warn(`parseContent var not found "${text}"`)
              return ''
            }
          } else {
            console.warn(`parseContent unknown type "${type}"`)
            return ''
          }
        })
        .join('')
        .replace(/\n/g, '<br>')
      if (color) {
        html = `<span style="color:${color};">${html}</span>`
      } else {
        html = `<span>${html}</span>`
      }
      return html
    },
    resetPlayer () {
      const { contentAudios } = this.game
      this.game.msgPlaying = false
      this.$audio.pause()
      this.$audio.volume = 1
      if (contentAudios.length > 0) {
        this.game.playIndex = 0
        this.$audio.src = contentAudios[0]
      }
    },
    playMsgAudio () {
      console.log('player.play')
      const { contentAudios, msgPlaying } = this.game
      if (!msgPlaying && contentAudios.length > 0) {
        this.game.msgPlaying = true
        this.$audio.play()
      }
    },
    replayMsgAudio () {
      const { contentAudios } = this.game
      if (contentAudios.length > 0) {
        this.game.msgPlaying = true
        this.game.playIndex = 0
        this.$audio.currentTime = 0
        this.$audio.play()
      }
    },
    pauseMsgAudio () {
      console.log('player.pause')
      this.$audio.pause()
      this.game.msgPlaying = false
    },
    async onAudioError (e) {
      console.log('on player.error', e)
      if (this.game.start && this.game.msgPlaying) {
        let { contentAudios, playIndex } = this.game
        if (this.$audioRetry && this.$audioRetry.times < 3) {
          this.$audioRetry.times += 1
          this.$audio.pause()
          console.log('audio retry', this.$audioRetry.times)
          this.$audio.currentTime = 0
          this.$audio.src = contentAudios[playIndex]
          this.$audio.play().catch(e => console.warn(e))
          return
        }
        if (!this.$audioRetry) {
          this.$audioRetry = {
            times: 0,
            src: this.$audio.src
          }
          this.$audio.pause()
          console.log('audio retry', this.$audioRetry.times)
          this.$audio.currentTime = 0
          this.$audio.src = contentAudios[playIndex]
          this.$audio.play().catch(e => console.warn(e))
        }
        if (this.$audioRetry.times >= 3) {
          if (contentAudios[playIndex + 1]) {
            playIndex += 1
            console.log('change src to', contentAudios[playIndex])
            this.game.playIndex = playIndex
            this.$audio.src = contentAudios[playIndex]
            this.$audio.currentTime = 0
            this.$audio.play()
          } else {
            this.game.playIndex = playIndex = 0
            this.$audio.src = this.game.contentAudios[playIndex]
            this.$audio.pause()
            this.game.msgPlaying = false
          }
          this.$audioRetry = null
        }
      }
    },
    onAudioEnd () {
      console.log('on player.end')
      if (this.game.start && this.game.msgPlaying) {
        let { contentAudios, playIndex } = this.game
        if (contentAudios[playIndex + 1]) {
          playIndex += 1
          this.game.playIndex = playIndex
          this.$audio.src = contentAudios[playIndex]
          this.$audio.currentTime = 0
          this.$audio.play()
        } else {
          this.game.playIndex = playIndex = 0
          this.$audio.src = this.game.contentAudios[playIndex]
          this.$audio.pause()
          this.game.msgPlaying = false
        }
      }
    },
    delay (t) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve()
        }, t)
      })
    }
  }
}
</script>

<style>
html {
  /* overflow: hidden !important; */
  font-family: mind524-font, serif;
}
</style>
<style lang="scss" scoped>
@mixin mini_scroll {
  &::-webkit-scrollbar {
    // position: relative;
    width: 4px;
  }
  /* Track */
  &::-webkit-scrollbar-track {
    background: none;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #aaa2;
  }
  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #fff2;
  }
}
@mixin mini_scroll_2 {
  &::-webkit-scrollbar {
    // position: relative;
    width: 4px;
  }
  /* Track */
  &::-webkit-scrollbar-track {
    background: none;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #aaa4;
  }
  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #fff4;
  }
}
// ----------- 通用 -----------
.pos-abs {
  position: absolute;
}

.hover:hover {
  cursor: pointer;
  opacity: 0.8;
}

.slide-fade-enter-active {
  transition: all 0.6s ease;
}
.slide-fade-leave-active {
  transition: all 0.6s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(100px);
  opacity: 0;
}

// ----------- 頁面區塊相關 -----------
.mind524-page {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #35275a;
  background-image: url('../assets/mind524/img/window-background.png');
  background-size: cover;
  overflow-y: hidden;
  overflow-x: hidden;
}
.game-screen {
  position: absolute;
  $gradient0: #f0f3f6;
  $gradient1: #79afff;
  $gradient2: #86218e;
  $gradient3: #2d1339;
  background: linear-gradient(270deg, $gradient0 0%, $gradient1 33%, $gradient2 66%, $gradient3 100%);
  background: -moz-linear-gradient(270deg, $gradient0 0%, $gradient1 33%, $gradient2 66%, $gradient3 100%);
  background: -webkit-linear-gradient(270deg, $gradient0 0%, $gradient1 33%, $gradient2 66%, $gradient3 100%);
  background: -o-linear-gradient(270deg, $gradient0 0%, $gradient1 33%, $gradient2 66%, $gradient3 100%);
}
.text-wave-bg-wrapper {
  overflow: hidden;
}
.text-wave-bg {
  position: absolute;
  left: 50%;
  overflow-y: hidden;
  overflow-x: hidden;
  border-radius: 37%;
  transform: translateX(-50%);
}
.main-content-area {
  // @include mini_scroll;
  position: absolute;
  box-sizing: border-box;
  overflow: hidden;

  .top-title {
    padding: 42px 42px 0px 42px;
    text-align: center;
  }
  .top-content {
    // background-color: #665AB199;
    background-image: url('../assets/mind524/img/bg-purple.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    margin: 10px 20px 0px 20px;
    padding: calc(8vh) 27px 47px 34px;
    // border-radius: 15px;
    font-size: 16px;

    // box-shadow: 0px 5px 10px #0002;
    // padding-right: 50px;
    .main-content {
      @include mini_scroll;
      height: 90%;
      padding-right: 10px;
      white-space: normal;
      overflow-y: scroll;
      overflow-x: hidden;
    }
  }
  .content-player-outer {
    position: absolute;
  }
}
.bottom-loadding {
  position: absolute;
  box-sizing: border-box;
  color: #fff2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  .bottom-loadding-img-wrapper {
  }
}
.float-area-outer {
  position: absolute;
  box-sizing: border-box;

  // box-shadow: 0px -10px 20px #0002;
  .float-area {
    overflow: hidden;
    background: #f5eef7;
    // border-radius: 20px 20px 0 0;
    // height: 100%;
    padding-top: 20px;
    padding-left: 18px;
    padding-right: 24px;
  }

  .date-area {
    & > div {
      display: flex;
      padding-left: 18px;
      padding-right: 12px;
      justify-content: space-between;
      font-size: 12px;
    }
  }
  .bottom-title-1 {
    & > div {
      @include mini_scroll_2;
      width: 100%;
      height: 100px;
      padding-left: 18px;
      padding-right: 18px;
      white-space: normal;
      overflow-y: scroll;
      overflow-x: hidden;
    }
  }
  .mic-area {
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .pencil-area {
    position: absolute;
    bottom: 0;
    left: 0;
  }
}

// ----------- 其他元件相關 -----------
.start-view-float-desc {
  position: absolute;
  top: 350px;
  left: 0;
  width: 100%;
  text-align: center;
  line-height: 2.5;
  color: white;
  font-size: 14px;
}
.start-view-mute {
  position: absolute;
  top: 130px;
  left: calc(50% + 40px);
  .start-view-mute-btn {
    background-color: #f2c94c;
    border-radius: 30px;
    height: 30px;
    width: 30px;
  }
}
.start-view {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: #212222;
  .start-img-voiss {
    height: 160px;
  }
  .start-view-innert {
    position: absolute;
    width: 100%;
    top: 17%;
    left: 0;
  }
  .input-form {
    position: absolute;
    left: 0;
    left: 0;
    width: 100%;
    text-align: center;
    .form-content {
      display: inline-block;
      margin-top: 30px;
      padding: 12px;
      padding-top: 0px;
      min-width: 40%;
      width: 150px;
      max-width: 80%;
      background-color: white;
      box-shadow: 0px 5px 10px #0002;
      border-radius: 15px;
      & > * {
        margin-top: 12px;
      }
    }
    .text-input {
      width: 100%;
      background-color: #ccc;
      padding: 4px;
      border-radius: 4px;
      color: black;
      text-align: center;
    }
    .login-btn {
      background-color: #4e4da8;
      padding: 4px;
      padding-right: 8px;
      padding-left: 8px;
      border-radius: 8px;
      font-size: 14px;
      color: white;
    }
    .start-btn {
      width: 100%;
      background-color: #4e4da8;
      padding: 4px;
      border-radius: 8px;
      font-size: 14px;
      color: white;
    }
  }
}
@media screen and (max-height: 600px) {
  .start-view {
    .start-view-innert {
      top: 8%;
    }
  }
}
@media screen and (max-height: 500px) {
  .start-view {
    .start-view-innert {
      top: 0%;
    }
  }
}
</style>
